module.exports = __webpack_public_path__ + "img/inovacao.6444aa7b.png";